import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { promosRoutes } from '../promos/promo.routes'; 
import { usersRoutes } from '../user/user.routes';
import { authRoutes } from '../auth/auth.routes';
import { homeRoutes } from '../home/home.routes';
import { tagsRoutes } from '../tags/tag.routes';
import { booksRoutes } from '../book/book.routes';
import { reservationsRoutes } from '../reservation/reservation.routes';
import { mailchimpRoutes } from '../mailchimp/mailchimp.routes';
import { transactionsRoutes } from '../transaction/transaction.routes';
import { consultationsRoutes } from '../consultation/consultation.routes';
import { settingsRoutes } from '../settings/settings.routes';
import { rankingRoutes } from '../ranking/ranking.routes';
import { bannerRoutes } from '../banner/banner.routes';
import { carouselRoutes } from '../carousel/carousel.routes';
import { newsRoutes } from '../news/news.routes';

const routes: Routes = [
  ...homeRoutes,
  ...promosRoutes,
  ...usersRoutes,
  ...authRoutes,
  ...tagsRoutes,
  ...booksRoutes,
  ...reservationsRoutes,
  ...consultationsRoutes,
  ...transactionsRoutes,
  ...settingsRoutes,
  ...mailchimpRoutes,
  ...rankingRoutes,
  ...newsRoutes,
  ...bannerRoutes,
  ...carouselRoutes
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing/app-routing.module.ts